// constants
import { USERS_USER_TYPE_VALUE_ADMIN } from "../../../constants/users";

/**
 * Retourne vrai si l’utilisateur courant est l’utilisateur racine.
 */
export default function usersIsRoot({ user }) {
  return 1 === user?.id && USERS_USER_TYPE_VALUE_ADMIN === user?.user_type;
}
